// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PinInput } from '@mantine/core';
import { Anchor, Badge, Button, Center, Group, Stack, Text, Title } from '@/components/ui';
import { IconArrowLeft, IconSparkles, IconShieldCheck, IconMail } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function OtpModern() {
  const [otp, setOtp] = useState('');
  const [step] = useState(2); // Current step in authentication flow

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('OTP submitted:', otp);
  };

  return (
    <AuthLayoutWrapper variant="modern">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/otp"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Progress indicator */}
        <Group justify="center" gap="xs">
          <Badge color="violet" variant="filled" circle>1</Badge>
          <div style={{ width: 40, height: 2, backgroundColor: 'var(--mantine-color-violet-6)' }} />
          <Badge color="violet" variant="filled" circle>2</Badge>
          <div style={{ width: 40, height: 2, backgroundColor: 'var(--mantine-color-gray-3)' }} />
          <Badge color="gray" variant="outline" circle>3</Badge>
        </Group>

        {/* Header */}
        <Stack align="center" gap="xs">
          <Badge
            leftSection={<IconSparkles size={12} />}
            variant="gradient"
            gradient={{ from: 'violet', to: 'grape' }}
            size="lg"
          >
            Two-Factor Authentication
          </Badge>

          <Center
            mt="sm"
            style={{
              width: 72,
              height: 72,
              borderRadius: 18,
              backgroundColor: 'var(--mantine-color-violet-light)',
            }}
          >
            <IconShieldCheck size={36} color="var(--mantine-color-violet-6)" />
          </Center>

          <Title order={2} ta="center" mt="sm">Verify your identity</Title>
          <Text c="dimmed" size="sm" ta="center" maw={300}>
            We've sent a verification code to your email. Enter it below to continue.
          </Text>

          <Group gap="xs" mt="xs">
            <IconMail size={16} color="var(--mantine-color-dimmed)" />
            <Text size="sm" c="dimmed">j***n@example.com</Text>
          </Group>
        </Stack>

        {/* OTP Input */}
        <form onSubmit={handleSubmit}>
          <Stack gap="lg">
            <Center>
              <PinInput
                length={6}
                size="xl"
                value={otp}
                onChange={setOtp}
                type="number"
                oneTimeCode
                styles={{
                  input: {
                    borderRadius: 12,
                    fontWeight: 600,
                  },
                }}
              />
            </Center>

            <Button
              type="submit"
              fullWidth
              size="md"
              radius="md"
              variant="gradient"
              gradient={{ from: 'violet', to: 'grape' }}
              disabled={otp.length !== 6}
            >
              Verify & Continue
            </Button>
          </Stack>
        </form>

        {/* Resend options */}
        <Stack gap="xs" align="center">
          <Group gap="md">
            <Anchor component="button" type="button" size="sm" c="violet">
              Resend code
            </Anchor>
            <Text size="sm" c="dimmed">•</Text>
            <Anchor component="button" type="button" size="sm" c="violet">
              Use authenticator app
            </Anchor>
          </Group>
        </Stack>

        {/* Back to Login */}
        <Center>
          <Button
            component={Link}
            to="/demo/auth-pages/login/modern"
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
          >
            Cancel and go back
          </Button>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
